import { Box, VStack, Skeleton, SkeletonCircle, HStack } from '@chakra-ui/react';

const ProviderCardSkeleton = () => {
  return (
    <VStack marginTop="55px" position="relative">
      {/* Avatar floating above the card */}
      <Box position="absolute" top="-55px" left="50%" transform="translateX(-50%)" zIndex={1}>
        <SkeletonCircle size="110px" />
      </Box>

      {/* Card */}
      <Box position="relative" w="295px" h="310px" borderRadius="10px" boxShadow="0px 10px 80px 0px #00417926" p="20px">
        {/* Background shimmer */}
        <Skeleton position="absolute" inset="0" startColor="gray.100" endColor="gray.200" borderRadius="10px" />

        {/* Foreground content */}
        <Box position="relative">
          {/* Name */}
          <Skeleton height="5" mt="60px" width="60%" mx="auto" mb={6} borderRadius={'4px'} />

          {/* Age & phone number */}
          <HStack justify="space-between" mb={5}>
            <VStack align="start" spacing={1}>
              <Skeleton height="3" width="70px" borderRadius={'4px'} />
              <Skeleton height="4" width="90px" borderRadius={'4px'} />
            </VStack>
            <VStack align="start" spacing={1}>
              <Skeleton height="3" width="90px" borderRadius={'4px'} />
              <Skeleton height="4" width="110px" borderRadius={'4px'} />
            </VStack>
          </HStack>

          {/* Bio */}
          <VStack align="start" spacing={2}>
            <Skeleton height="3" width="40px" borderRadius={'4px'} />
            <Skeleton height="4" width="full" borderRadius={'4px'} />
            <Skeleton height="4" width="90%" borderRadius={'4px'} />
            <Skeleton height="4" width="80%" borderRadius={'4px'} />
          </VStack>

          {/* Read more */}
          <Skeleton height="3" width="80px" mt={4} borderRadius={'4px'} />
        </Box>
      </Box>
    </VStack>
  );
};

export default ProviderCardSkeleton;
